
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmMuteControl,
  VmControl,
  VmIcon,
  VmTooltip 
} from '@vime/core';

import { define } from '../lib';
  

const MuteControlInputs: string[] = [
  'lowVolumeIcon',
  'highVolumeIcon',
  'mutedIcon',
  'icons',
  'tooltipPosition',
  'tooltipDirection',
  'hideTooltip',
  'keys',
  'volume',
  'muted',
  'i18n',
];

const MuteControlMethods: string[] = [
  
];

const MuteControlOutputs: string[] = [
  'vmFocus',
  'vmBlur',
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface MuteControl extends Components.VmMuteControl {}

@ProxyCmp({
  inputs: MuteControlInputs,
  methods: MuteControlMethods,
})
@Component({
  selector: 'vm-mute-control',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: MuteControlInputs,
  outputs: MuteControlOutputs,
})
export class MuteControl {
  protected el: HTMLElement;

  /** Emitted when the control receives focus. */
  vmFocus!: Emitter<JSX.VmMuteControl["onVmFocus"]>;
  /** Emitted when the control loses focus. */
  vmBlur!: Emitter<JSX.VmMuteControl["onVmBlur"]>;

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-mute-control', VmMuteControl);
    define('vm-control', VmControl);
    define('vm-icon', VmIcon);
    define('vm-tooltip', VmTooltip);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, ['vmFocus', 'vmBlur'])
  }
}
  